import _ from 'lodash';
import products from './products.js';
import {isNumeric} from './number.js'

//get initial schema for a given type
const initialValues = {};
const getInitialValues = (type) => {
  type = type.replace('fresh_web_', '');

  if (initialValues.hasOwnProperty(type)) return initialValues[type];

  try {
    const schema = require(`../schemes/form/schema.${type}`).default;
    const values = {};
    _.each(schema, (val, key) => {
      if (key.match(/occupation_x_type/)) {
        values['occupation_0_type'] = _getFirstOccupationValue(type);
      }
      if (!key.match(/^\w+_x_(\w+)?$/)) values[key] = val.value;
    });
    if (!_.isEmpty(values)) initialValues[type] = values;
    return values;

  } catch (e) {
    console.error(`Schema ${type} failed to load!`);
    console.error(e);
    return {};
  }
};

const _getFirstOccupationValue = type => {
  let out = '';
  switch (type) {
    case products.taxi:
      out = 'taxi driver';
      break;
    case products.courier:
      out = 'courier';
      break;
    default:
      break;
  }
  return out;
};

// given a record of keys from stepform, find ones that are multiples of itself such as: driver_0_name, driver_1_name, and shorten it to only one key: driver_x_name
// the second parameter accepts an array that validates whether or not it should be transformed based on its first word, e.g ['driver', 'claim']
const shortenKeys = (keys, withMultiples) => {
	for (const key in keys) {
		const split = key.split('_')

		for (let i = 0; i < split.length; ++i) {
			if (isNumeric(split[i]) && withMultiples.includes(split[0])) {
				const firstPortion = split.slice(0, i).join('_')
				const secondPortion = split.slice(i + 1).join('_')
				keys[`${firstPortion}_x_${secondPortion}`] = 'shortened'
				delete keys[key]
			}
		}
	}

	return keys
}

export {getInitialValues, shortenKeys};
